import { useParams } from "react-router-dom";
import axiosInstance from "interceptor/axiosInstance";
import { useEffect, useState } from "react";
import BlockRenderer from "components/BlockRenderer";
import { Meta } from "types/cms/Meta";
import useRedirect from "hooks/useRedirect";

export default function PageTemplate() {
    useRedirect();

    const { slug } = useParams();
    let isBlogs: boolean = false;
    let singleBlogSlug: any = "";
    if (slug?.includes("blogs")) {
        isBlogs = true;
        singleBlogSlug = window.location.href.split("/").pop();
    }

    const [pageData, setPageData] = useState<any>(null);
    const [meta, setMeta] = useState<Meta | null>(null);
    useEffect(() => {
        axiosInstance
            .get(`/${isBlogs ? "blogs" : "pages"}?where[slug][equals]=${isBlogs ? singleBlogSlug : slug}&depth=3&draft=false`)
            .then((response) => {
                setPageData(response.data.docs[0]);
                setMeta(response.data.docs[0].meta);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [slug]);

    if (!pageData) {
        return <div>Loading...</div>;
    } else {
        if (meta && meta.title && meta.description) {
            document.title = `${meta?.title} | CRASHLAW`;
            document.querySelector('meta[name="description"]')?.setAttribute('content', meta?.description ?? '');
            // og:description needs to be limited to 71 chars, so strip from the start if necessary
            const ogDescription = meta?.description ?? '';
            const trimmedOgDescription = ogDescription.length > 71 ? ogDescription.slice(-71) : ogDescription;
            document.querySelector('meta[property="og:description"]')?.setAttribute('content', trimmedOgDescription);
        }
    }

    return (
        <main>
            <BlockRenderer blocks={pageData.layout} />
        </main>
    );
}
